module.exports = __webpack_public_path__ + "static/media/shovel.8a22613d.svg";